export enum FilterModeEnum {
  OWN = 'own',
  MODEL = 'model',
  SEARCH = 'search',
  HIGHLIGHTS = 'highlights'
}
